import { apiSlice } from '@/api';
import { Area, Zone, Country } from './types';

const locationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<Country[], void>({
      query: () => ({
        url: 'v1/country/all',
      }),
    }),
    getAreas: builder.query<Area[], { countryId: number }>({
      query: ({ countryId }) => ({
        url: `v1/area?countryId=${countryId}`,
      }),
    }),
    getZones: builder.query<Zone[], { areaId: number }>({
      query: ({ areaId }) => ({
        url: `v1/zone?areaId=${areaId}`,
      }),
    }),
    getArea: builder.query<any, { areaId: number }>({
      query: ({ areaId }) => ({
        url: `v1/area/${areaId}`,
      }),
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useGetAreasQuery,
  useGetZonesQuery,
  useGetAreaQuery,
} = locationApiSlice;
